import { PkgContent, PkgShippingMethod } from '@/api/user-package/types/UserPkg'

export enum PaymentMethod {
  CreditCard = 'creditCard',
  GooglePay = 'googlePay',
  ApplePay = 'applePay',
  Bit = 'bit',
}

export interface CreatePaymentLinkPayload {
  pkgId: string
  shippingMethod: PkgShippingMethod
  contentVal: string
  couponDiscount: number
  couponCode: string
  shippingAddressId: string
  paymentMethod: PaymentMethod
  contents: PkgContent[]
  country: string
  insurance?: number
  costumerIsraeliId?: string
  creditToUseInILS?: number
}
